<template>
    <div>
        <h1>
            Добавить место
        </h1>
        <transfer-places-add-form />
    </div>
</template>

<script>
import TransferPlacesAddForm from '@/modules/transfer/components/TransferPlacesAddForm';

export default {
    name: 'TransferPlacesAddView',
    components: { TransferPlacesAddForm }
};
</script>

